import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notContains'
})
export class NotContainsPipe implements PipeTransform {

  transform(items:any[], values:any[], property?:string): any[] {
    if(!items || !items.length){
      return [];
    }
        
    if(!values || !values.length){
        return items;
    }

    return items.filter(item => (property ?values.indexOf(item[property]) : values.indexOf(item))== -1);
   }

}
 